import type { CardArt, CardArtContext } from './cardArt';
import { FACE_VERSION, faceFor } from './faces';
import { paintFace } from './painter';
import { tuneVersion } from './tune';

/**
 * **牌面的 `CardArt` 实现** —— 把「纯几何」和「Pixi」接起来的那一根线。
 *
 * 它是全项目**唯一**一个 `CardArt`：所有 13 张牌共用它，
 * 具体画什么由 `faceFor(card)` 按 `traits` 分派。
 *
 * 所以「加一张新牌」的完整动作是：在 `faces/` 里加一个分支，
 * **不需要新建 `CardArt`、不需要注册、不需要动渲染层**。
 * 这和 `docs/card-rendering.md` 里"每种牌写一个 CardArt"的设想不同 ——
 * 那种做法会让 56 张牌有 56 份重复的管线代码，而它们的差别其实只在画面。
 */
export const specArt: CardArt = {
  /**
   * ⚠️ 版本号必须包含 `tuneVersion()`：调优面板改了参数之后，
   * 牌面缓存要认得出"内容变了"才会重画。
   */
  revision: () => `${FACE_VERSION}.${tuneVersion()}`,

  build: ({ card, width, height }: CardArtContext) =>
    paintFace(faceFor(card), { width, height }),
};
